import { FuseAnimateGroup } from "@fuse";
import { Avatar, Divider, Typography, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import { getAcronimo } from "app/Core/Helpers";
import clsx from 'clsx';
import dayjs from "dayjs";
import _ from 'lodash';
import MobileDetect from 'mobile-detect';
import React from 'react';
import ComunicadorApp from "../ComunicadorApp";
import Factory from "../Gerenciadores/Factory";
import MensagemPermissao from "./MensagemPermissao";
import MensagemTag from "./MensagemTag";

const md = new MobileDetect(window.navigator.userAgent);


const styles = theme => ({
    defaultColor: {
        color: theme.palette.type === "dark" ? "#CCC" : "#666",
        textDecoration: "none !important",
        "&:hover": {
            textDecoration: "none !important",
            color: theme.palette.type === "dark" ? "#CCC" : "#666",
        },
        "&:focus": {
            textDecoration: "none !important",
            color: theme.palette.type === "dark" ? "#CCC" : "#666",
        }
    },
    box: {
        border: "1px solid " + theme.palette.divider,
        "&:hover": {
            boxShadow: "0px 0px 2px 0px " + theme.palette.divider,
        },
        "&.novo": {
            fontWeight: 700,
            borderColor: theme.palette.type === 'light' ? '#303030' : '#E6E6E6',
            "&:hover": {
                boxShadow: "0px 0px 2px 0px " + (theme.palette.type === 'light' ? '#303030' : '#E6E6E6'),
            }
        },
        "&.selected": {
            fontWeight: 500,
            borderColor: theme.palette.type === 'light' ? '#303030' : '#E6E6E6',
            boxShadow: "0px 0px 2px 0px " + (theme.palette.type === 'light' ? '#303030' : '#E6E6E6'),
        }
    },
    contrastBackground: {
        backgroundColor: theme.palette.background.paper,
    },
    observacao: {
        backgroundColor: theme.palette.type === "dark" ? "#262933" : "#C5C6CB",
    }
});

class MensagemCard extends XAPPComponent {

    state = {
        hover: false
    }

    render() {
        const { data, xappRouteParams, Comunicador, theme, classes, locais, setOpenMessage, expanded = null, parametros, save, callback, showLocal = false, showTags = true, getFilter } = this.props;
        const { hover } = this.state;
        let ACorDestaque = theme?.palette.secondary.main;

        return (
            <React.Fragment>
                <FuseAnimateGroup animation="transition.slideDownIn" delay={300}>
                    <div
                        className={clsx(classes.box, "block w-full mb-8 cursor-pointer min-h-44", ("Header" + data.idmensagem), classes.contrastBackground, data.lido === 0 && "novo", !_.isNull(expanded) && expanded.idmensagem === data.idmensagem && "selected")}
                        key={"Agendamento_" + data.idmensagem}
                        style={{ borderLeft: `8px solid ${ACorDestaque}` }}
                        onClick={() => {
                            if (!_.isNull(expanded) && expanded.idmensagem === data.idmensagem) {
                                setOpenMessage();
                            }
                            else {
                                getFilter("SELECIONAR", xappRouteParams, {
                                    "AND": [
                                        { "Campo": "mensagem.idmensagem", "Operador": "=", "Valor": data.idmensagem },
                                        { "Campo": "mensagemlocal.idmensagemlocal", "Operador": "=", "Valor": data.idmensagemlocal }
                                    ]
                                });
                            }
                        }}
                        onMouseOut={() => this.setState(_.set({ ...this.state }, "hover", false))}
                        onMouseOver={() => this.setState(_.set({ ...this.state }, "hover", true))}
                    >
                        {parametros.idlocal === -1 &&
                            <Typography className="text-11 mx-8 px-4 flex w-fit">{data.localnome}</Typography>
                        }
                        <div className={clsx("flex flex-row w-full px-8 items-center gap-8 min-h-44")} >
                            {/* <MinhasTarefasTagChip
                            itens={getTagsHeader(data)}
                            className="p-8"
                        /> */}
                            <Avatar
                                alt={`Foto_${data.remetente}`}
                                src={""}
                                className="h-32 w-32 text-16"
                            >
                                {getAcronimo(data.remetente)}
                            </Avatar>
                            <div className={clsx("flex flex-col w-1/3")}>
                                <span className="text-10 whitespace-no-wrap">
                                    {data.remetenteorganizacao}
                                </span>
                                <span className="">
                                    {data.remetente}
                                </span>
                            </div>
                            <Divider className={clsx(classes.defaultColor, "w-px h-36 mx-8")} />
                            <div className={clsx("flex flex-col w-2/3")}>
                                {showLocal &&
                                    <span className="text-10 whitespace-no-wrap">
                                        {data.localnome}
                                    </span>
                                }
                                <span className="">
                                    {data.assunto}
                                </span>
                            </div>
                            <div className="flex-1" />
                            <div className={clsx(hover ? "hidden" : "flex")}>
                                <span className="text-11 whitespace-no-wrap">
                                    {dayjs(data.dataupt).format("DD/MM/YYYY HH:mm")}
                                </span>
                            </div>
                            <div className={clsx(hover ? "flex" : "hidden")} onClick={ev => ev.stopPropagation()}>
                                {showTags &&
                                    <MensagemTag
                                        idmensagem={data.idmensagem}
                                        selected={data.tags}
                                        idlocal={data.idlocal}
                                        Tags={!_.isNull(parametros.idlocal) ? _.find(locais, { idlocal: parametros.idlocal })?.tags : []}
                                        xappRouteParams={xappRouteParams}
                                        save={save}
                                        callback={callback}
                                    />
                                }
                                {/* <MensagemPermissao
                                    idmensagem={data.idmensagem}
                                    selected={data.grupospermissao}
                                    idlocal={data.idlocal}
                                    Grupos={!_.isNull(Comunicador.grupospermissao) ? Comunicador.grupospermissao : []}
                                    xappRouteParams={xappRouteParams}
                                    save={save}
                                    callback={callback}
                                /> */}
                            </div>
                        </div>
                        {!_.isNull(expanded) && expanded.idmensagem === data.idmensagem &&
                            <div className={clsx(classes.box, "flex flex-row w-full px-8 items-center gap-8 border-t-0")} >
                                <span className={clsx("flex flex-col w-full")}>
                                    {!_.isNull(expanded.conteudo) &&
                                        <div dangerouslySetInnerHTML={{ __html: expanded.conteudo }} />
                                    }
                                </span>
                            </div>
                        }
                    </div>
                </FuseAnimateGroup>
            </React.Fragment >
        );
    }
}


export default withStyles(styles, { withTheme: true })(MensagemCard);
